import * as z from "zod";

export const splitShipmentLocationGroupSchema = z.object({
  profileId: z.string().min(1),
  locationGroupId: z.string().min(1),
});
export type SplitShipmentLocationGroup = z.infer<
  typeof splitShipmentLocationGroupSchema
>;

export const splitShipmentLocationGroupsViewSchema = z.object({
  snapshot: z.string(),
  groups: z.array(
    splitShipmentLocationGroupSchema.extend({
      profileName: z.string(),
      locationNames: z.array(z.string()),
      methodNames: z.array(z.string()),
      hasCalculatedRates: z.boolean(),
      unavailableReason: z.string().optional(),
    }),
  ),
});
export type SplitShipmentLocationGroupsView = z.infer<
  typeof splitShipmentLocationGroupsViewSchema
>;
